import React from "react";

// assets
import CloseIcon from "bodycodi/cmap/app/svg/icon_x_medium.svg";
import DisabledCloseIcon from "bodycodi/cmap/app/svg/icon_x_disabled.svg";

const SNSLinks = ({ snsLinks, setSnsLinks }: any) => {
  const addNewSnsLink = () => {
    const newId =
      "new+" + new Date().valueOf().toString(36) + Math.random().toString(36).substring(2);
    setSnsLinks({
      ...snsLinks,
      displayLinks: [...snsLinks.displayLinks, { seqPlusSellerLink: newId, snsLink: "" }],
    });
  };

  const removeSnsLink = (idToRemove: any) => {
    const updatedLinks = snsLinks.displayLinks.filter(
      (link: any) => link.seqPlusSellerLink !== idToRemove
    );

    let deletedLinks = snsLinks.deletedLinks;
    if (typeof idToRemove === "number") {
      deletedLinks = [...deletedLinks, { seqPlusSellerLink: idToRemove, useYn: "N" }];
    }

    setSnsLinks({ ...snsLinks, displayLinks: updatedLinks, deletedLinks });
  };

  const handleInputChange = (idToUpdate: any, value: any) => {
    const displayLinks = snsLinks.displayLinks.map((link: any) => {
      if (link.seqPlusSellerLink === idToUpdate) {
        let updatedLink = { ...link, snsLink: value };

        if (typeof idToUpdate === "number") {
          updatedLink.useYn = "Y";
        }

        return updatedLink;
      } else {
        return link;
      }
    });

    setSnsLinks({ ...snsLinks, displayLinks });
  };

  return (
    <div className="sns-links">
      <span>SNS 링크</span>

      <div className="list">
        {snsLinks?.displayLinks?.map((link: any) => {
          return (
            <ListItem
              key={link.seqPlusSellerLink}
              id={link.seqPlusSellerLink}
              value={link.snsLink}
              onChange={handleInputChange}
              onDelete={removeSnsLink}
            />
          );
        })}
      </div>

      <button onClick={addNewSnsLink} disabled={snsLinks.length >= 5}>
        SNS 추가하기
      </button>
    </div>
  );
};

const ListItem = ({ id, value, onChange, onDelete }: any) => {
  return (
    <div className="item">
      <input
        placeholder="인스타그램 또는 유튜브 링크를 입력해주세요"
        value={value}
        onChange={(e) => onChange(id, e.target.value)}
      />
      <button onClick={() => onDelete(id)}>
        <img src={value ? CloseIcon : DisabledCloseIcon} />
      </button>
    </div>
  );
};
export default SNSLinks;
